module.exports = __webpack_public_path__ + "assets/img/classroom_2.b27c8af2.jpg";